import { createFeatureSelector } from '@ngrx/store';
import { CfgTeamState } from './reducer/cfg-team.reducer';
import { StoreKeys } from '../../../models/store-keys';

export const selectCfgTeamFeature = createFeatureSelector<CfgTeamState>(StoreKeys.CFG_TEAM);

